import { render } from "./ExchangeCoin.vue?vue&type=template&id=f2ec78b8&ts=true"
import script from "./ExchangeCoin.vue?vue&type=script&lang=ts"
export * from "./ExchangeCoin.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__